export default {
  projectFilterLabel: 'Projects',
  export: 'Export',
};
